import React from 'react';
import { useCart } from '../contexts/CartContext';
import { Link, useNavigate } from 'react-router-dom';

export default function Cart() {
  const { cart, updateItemQty, removeItem, getSubtotal } = useCart();
  const navigate = useNavigate();
  console.log('[Cart] cartId?', cart?.id, 'items?', cart?.items?.length, 'raw cart =', cart);
  const items = cart?.items || [];

  if (items.length === 0) {
    return (
      <div className="page-container">
        <h1>Your Cart</h1>
        <p>Your cart is empty.</p>
        <Link className="shop-now-btn" to="/shop">Continue Shopping</Link>
      </div>
    );
  }

  return (
    <div className="page-container">
      <h1>Your Cart</h1>
      <div className="products-table-container">
        <table className="products-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Unit Price</th>
              <th>Quantity</th>
              <th>Subtotal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((it, idx) => (
              <tr key={idx}>
                <td>
                  <strong>{it.title}</strong>
                </td>
                <td>${(it.price || 0).toFixed(2)}</td>
                <td>
                  <input type="number" min={1} value={it.qty || 1} onChange={(e)=>updateItemQty(idx, parseInt(e.target.value || '1', 10))} style={{ width: 70 }} />
                </td>
                <td>${(((it.price || 0) * (it.qty || 1))).toFixed(2)}</td>
                <td>
                  <button className="delete-button" onClick={()=>removeItem(idx)}>Remove</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="form-actions" style={{ justifyContent: 'space-between' }}>
        <Link className="button" to="/shop">Continue Shopping</Link>
        <div>
          <strong style={{ marginRight: 16 }}>Total: ${getSubtotal().toFixed(2)}</strong>
          <Link className="submit-button" to="/order-summary">Checkout</Link>
        </div>
      </div>
    </div>
  );
}



